import { render } from "./ShimmerCards.vue?vue&type=template&id=6945e2fc&scoped=true"
import script from "./ShimmerCards.vue?vue&type=script&lang=js"
export * from "./ShimmerCards.vue?vue&type=script&lang=js"

import "./ShimmerCards.vue?vue&type=style&index=0&id=6945e2fc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6945e2fc"]])

export default __exports__